import featuresData from "../data/featuresData.js";
import FeatureCard from "./FeatureCard";

export default function WhyChooseUs() {
  return (
    <section>
      <div className="container">
        <div className="features-grid">
          {featuresData.map(f => <FeatureCard key={f.id} {...f} />)}
        </div>
      </div>
    </section>
  );
}